module.exports = __webpack_public_path__ + "img/Frente-16-01 on.dd505313.png";